export default __webpack_public_path__ + "static/clutch3-98c892d381139d00f3dbb8ee253dccd3.png";